module.exports = __webpack_public_path__ + "static/img/manual_ja_36.0455206.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_36.png
// module id = RP/L
// module chunks = 4